var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('span',{staticClass:"spinner-border mr-2",attrs:{"role":"status","aria-hidden":"true"}}),(!_vm.noText)?_c('p',[_vm._v("Loading...")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }